import { ReactNode } from 'react';
import './TabbarLayout.css'

const TabbarLayout = ({ children }: { children: ReactNode }) => (
  <div className='tabbar-layout'>
    {children}
  </div>
);

export default TabbarLayout;